import {RESERVATION_NAME_SAVE_FAILED_TEXT} from "../constants/reservation_copy";
import {isDisplayableApiMessage, isString} from "./api_error_text";
import {isRecord} from "./is_record";

// every text of a DRF error, as one line
const readTexts = (value: unknown): string =>
    (Array.isArray(value) ? value : [value])
        .filter(isString)
        .map((text) => text.trim())
        .filter((text) => text !== "")
        .join(" ");

/**
 * `data` - the body of a rejected profile update.
 * The error on the `name` field says what is wrong with the typed name, so it goes first; anything unreadable gets the generic copy.
 */
export const getNameSaveErrorMessage = (data: unknown): string => {
    if (!isRecord(data)) {
        return RESERVATION_NAME_SAVE_FAILED_TEXT;
    }

    return [data.name, data.detail, data.non_field_errors].map(readTexts).find(isDisplayableApiMessage) ?? RESERVATION_NAME_SAVE_FAILED_TEXT;
};
import {RESERVATION_NAME_SAVE_FAILED_TEXT} from "../constants/reservation_copy";
import {isDisplayableApiMessage, isString} from "./api_error_text";
import {isRecord} from "./is_record";

// every text of a DRF error, as one line
const readTexts = (value: unknown): string =>
    (Array.isArray(value) ? value : [value])
        .filter(isString)
        .map((text) => text.trim())
        .filter((text) => text !== "")
        .join(" ");

/**
 * `data` - the body of a rejected profile update.
 * The error on the `name` field says what is wrong with the typed name, so it goes first; anything unreadable gets the generic copy.
 */
export const getNameSaveErrorMessage = (data: unknown): string => {
    if (!isRecord(data)) {
        return RESERVATION_NAME_SAVE_FAILED_TEXT;
    }

    return [data.name, data.detail, data.non_field_errors].map(readTexts).find(isDisplayableApiMessage) ?? RESERVATION_NAME_SAVE_FAILED_TEXT;
};
